<template>
    <div>
        <GChart
                :type="type"
                :data="data"
                :options="options"
        />
    </div>
</template>

<script>
    import {GChart} from 'vue-google-charts'

    export default {
        components: {
            GChart
        },
        props: {
            data: {
                type: Array,
                default: () => []
            },
            type: {
                type: String,
                default: 'LineChart'
            },
            chartOptions: {
                type: Object,
                default: {}
            }
        },
        data() {
            return {
                options: {
                    ...this.chartOptions
                }
            };
        },
        mounted() {
        },
        methods: {}
    }
</script>
